import { render, staticRenderFns } from "./usuarios.vue?vue&type=template&id=f6f4df78&scoped=true"
import script from "./usuarios.vue?vue&type=script&lang=js"
export * from "./usuarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6f4df78",
  null
  
)

export default component.exports